export class ImagensModel {
  id: string;
}

export class ProdutosModel {
  id: string;
  codigo: string;
  barra: string;
  descricao: string;
  informacao: string;
  unitario: number;
  estoque: number;
  grupo: string;
  unidade: string;
  imagens: ImagensModel[];

  constructor(data?: Partial<ProdutosModel>) {
    Object.assign(this, data);
  }
}

export interface PaginatedProdutosResponse {
  produtos: ProdutosModel[];
  totalItems: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
}

export interface ProdutosFilter {
  page: number;
  descricao: string;
  grupo: string;
}
